"use client";

import Link from "next/link";

import { cn } from "@perceptron/utils/cn";

import { Icon } from "./icon";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

const DEFAULT_DISCORD_URL = "https://discord.gg/fgBeaACQzE";

export type DiscordLinkProps = {
  ariaLabel: string;
  tooltip: string;
  href?: string;
  className?: string;
  iconClassName?: string;
};

export const DiscordLink = ({
  ariaLabel,
  tooltip,
  href = DEFAULT_DISCORD_URL,
  className,
  iconClassName,
}: DiscordLinkProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link
          aria-label={ariaLabel}
          className={cn("text-foreground hover:text-foreground transition-colors", className)}
          href={href}
          rel="noreferrer"
          target="_blank"
        >
          <Icon className={cn("mx-1 size-5", iconClassName)} name="discord" />
        </Link>
      </TooltipTrigger>
      <TooltipContent theme="dark">
        <p>{tooltip}</p>
      </TooltipContent>
    </Tooltip>
  );
};
